import { GWCA } from '~/lib/ca-constants';
import { GWUtils } from '~/utils/ca-utils';

customElements.define(
  'gw-quick-add-to-cart-form',
  class GWQuickAddToCartForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.productId = this.getAttribute('product-id');
    }

    connectedCallback() {
      this.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        this._handleFormSubmit();
      });

      this.addEventListener('click', (event) => {
        if (event.target.matches('[data-wishlist-remove]')) {
          const productCard = this.closest('.gw-product-card');
          const wishlistButton = productCard.querySelector('gw-wishlist-button');
          wishlistButton.dispatchEvent(new Event('click'));
        }

        if (event.target.matches('[data-saved-from-cart-remove]')) {
          this._handleRemoveFromSavedItems();
        }
      });
    }

    /**
     * Handles the form submission for adding a product to the cart.
     * @returns {void}
     */
    async _handleFormSubmit() {
      this.form.querySelector('[data-loader]').hidden = false;

      const formData = new FormData(this.form);

      const config = {
        method: 'POST',
        body: formData,
        headers: {
          Accept: `application/javascript`,
        },
      };

      try {
        const response = await fetch(routes.cart_add_url, config);

        if (response.error) {
          throw new Error(response.error);
        }

        const data = await response.json();
        const added = [data];
        document.dispatchEvent(new CustomEvent('CART_UPDATED', { detail: { added } }));

        GWUtils.notify(`
          <span>Product added to cart</span>
          <a href="/cart" class="gw-notification__link">View</a>
        `);
      } catch (error) {
        console.error(error);
      } finally {
        this.form.querySelector('[data-loader]').hidden = true;

        // Dispatch an event to update the saved items list
        if (!this.closest('[data-favorites-drawer-container]')) return;

        const productId = this.form.querySelector('[name="productId"]').value;
        const variantId = this.form.querySelector('[name="id"]').value;

        if (!productId || !variantId) return;
        const event = new CustomEvent(GWCA.CUSTOM_EVENTS.SAVED_ITEMS_FROM_CART, {
          detail: {
            productId: productId,
            variantId: variantId,
            target: this,
          },
        });

        GWUtils.app.dispatchEvent(event);
      }
    }

    /**
     * Handles removing a product from the saved items list.
     * @returns {void}
     */
    async _handleRemoveFromSavedItems() {
      if (!GWUtils.hasCustomer) {
        const productId = this.form.querySelector('[name="productId"]').value;
        const currentTEMPCartProducts = JSON.parse(localStorage.getItem(GWCA.STORAGE_KEYS.TEMP_CART_PRODUCTS)) || [];

        const updatedTEMPCartProducts = currentTEMPCartProducts.filter((product) => product.id != productId);

        localStorage.setItem(GWCA.STORAGE_KEYS.TEMP_CART_PRODUCTS, JSON.stringify(updatedTEMPCartProducts));

        GWUtils.dashboard.loadSavedCartItems();

        return;
      }

      this.form.closest('.gw-product-card').classList.add('gw-product-card--removing');

      const body = {
        prodID: this.form.querySelector('[name="productId"]').value,
      };

      try {
        const response = await GWUtils.request(GWCA.ENDPOINTS.CART.REMOVE, body);

        if (response.error) {
          throw new Error(response.error);
        }

        await GWUtils.dashboard.loadSavedCartItems();
      } catch (error) {
        console.error(error);
      }
    }
  }
);
